import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isFetching: false,
  success: '',
  isSuccess: false,
};

export default function createAutoRouting(state = initialState, action) {
  switch (action.type) {
    case actionConstants.AUTO_ROUTING_REQUEST:
      return {
        ...state,
        isFetching: true,
        isSuccess: false,
        error: '',
        success: ''
      };
    case actionConstants.AUTO_ROUTING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        success: action.message,
        isSuccess: true,
      };
    case actionConstants.AUTO_ROUTING_FAILURE:
      return {
        ...state,
        error: action.message,
        isFetching: false,
      };
    case actionConstants.CLEAR_STATE:
      return {
        ...state,
        error: '',
        success: '',
        isSuccess: false,
        isFetching: false,
      };
    case actionConstants.RESET_ALL_REDUCERS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
